




















import Vue from 'vue';
import { Component, Prop, InjectReactive } from 'vue-property-decorator';
import { AdminMenuItem } from 'frontend/types';
import { CourseData } from 'frontend/components/search/types';
import { track } from 'frontend/utils/analytics';
import { dumbSlugifySearchQuery } from 'frontend/utils/formatting';
import AdminMenu from 'frontend/components/AdminMenu.vue';

@Component({
  components: {
    AdminMenu,
  },
})
export default class CourseSearchCards extends Vue {
  @Prop(Array) readonly courses!: CourseData[];
  @Prop(String) readonly queryID!: string;
  @Prop(Number) readonly startPosition!: number;
  @InjectReactive() readonly searchQuery!: string;
  @Prop(Boolean) private inHeader!: boolean;
  @Prop(Boolean) private mobile!: boolean;
  @Prop(Boolean) private isStaffUser!: boolean;

  private clickAction: string = 'clicked_course_card';

  private getPosition(index: number): number {
    return this.startPosition + index;
  }

  private getAdminMenuBadges(course: CourseData) {
    const badges: string[] = [];

    if (!course.is_published) {
      badges.push('U');
    }

    return badges;
  }

  private getAdminMenuItems(course: CourseData) {
    const items: AdminMenuItem[] = [];

    if (!course.is_published) {
      items.push('Unpublished');
    }

    const domain = window.location.origin.includes('brilliant.org')
      ? 'https://admin.brilliant.org'
      : window.location.origin;
    const link = `${domain}/nexus/admin/assessment/section/${course.id}/change/`;

    items.push({
      link: [link, 'Edit Course'],
    });
    return items;
  }

  private getSearchEventDetails(courseData: CourseData, index: number) {
    return {
      query_id: this.queryID,
      action: this.clickAction,
      course_id: courseData.id,
      lesson_id: null,
      course_search_position: this.getPosition(index),
      lesson_search_position: null,
      query: dumbSlugifySearchQuery(this.searchQuery),
    };
  }

  private sendSearchClickEvent(courseData: CourseData, index: number) {
    track('course_search_event', this.getSearchEventDetails(courseData, index), {});
  }
}
